import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const calendarWeekDayFn = /* @__PURE__ */ createRecipe('calendar-week-day', {}, [])

const calendarWeekDayVariantMap = {}

const calendarWeekDayVariantKeys = Object.keys(calendarWeekDayVariantMap)

export const calendarWeekDay = /* @__PURE__ */ Object.assign(memo(calendarWeekDayFn.recipeFn), {
  __recipe__: true,
  __name__: 'calendarWeekDay',
  __getCompoundVariantCss__: calendarWeekDayFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: calendarWeekDayVariantKeys,
  variantMap: calendarWeekDayVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, calendarWeekDayVariantKeys)
  },
  getVariantProps: calendarWeekDayFn.getVariantProps,
})